import { computed } from 'vue'
import { SUPPLIER_NAV_KEYS, SUPPLIER_PATHS } from '@supplier/router/routeNames'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const NAV_ITEMS = [
  { key: SUPPLIER_NAV_KEYS.DASHBOARD, to: SUPPLIER_PATHS.DASHBOARD, labelKey: 'ui.supplier_portal.titles.dashboard' },
  { key: SUPPLIER_NAV_KEYS.PRODUCTS, to: SUPPLIER_PATHS.PRODUCTS, labelKey: 'ui.supplier_portal.titles.products' },
  { key: SUPPLIER_NAV_KEYS.ORDERS, to: SUPPLIER_PATHS.ORDERS, labelKey: 'ui.supplier_portal.titles.orders' },
  { key: SUPPLIER_NAV_KEYS.PAYOUTS, to: SUPPLIER_PATHS.PAYOUTS, labelKey: 'ui.supplier_portal.titles.payouts' },
]

export function useSupplierNav() {
  const route = useRoute()
  const { t } = useI18n()

  const items = computed(() => NAV_ITEMS.map((item) => ({
    ...item,
    label: t(item.labelKey),
    isActive: route.meta?.navKey === item.key,
  })))

  return { items }
}
